// SHADOW MARKET™ — Botón "Pagar con R₿L · 25% dto" (aditivo, junto al de EUR).
// Muestra el precio final con descuento y su equivalente live en R₿L.
import React, { useState } from "react";
import { Flame } from "lucide-react";
import { useCart } from "../../contexts/CartContext";
import { useAuth } from "../../contexts/AuthContext";
import { useLanguage } from "../../i18n/LanguageContext";
import { useMarketRblI18n } from "../../i18n/market-rbl";
import { useRBLPrice } from "../../hooks/useRBLPrice";
import RBLMarketCheckoutModal from "./RBLMarketCheckoutModal";

const RBL_MARKET_DISCOUNT = 0.25;

export const RBLPaymentButton = ({ onOpen }) => {
  const { items, compute } = useCart();
  const { isPro } = useAuth();
  const { lang } = useLanguage();
  const t = useMarketRblI18n(lang);
  const price = useRBLPrice();
  const [open, setOpen] = useState(false);

  if (!items.length) return null;

  const totals = compute(isPro);
  const discountedTotal = totals.subtotal * (1 - RBL_MARKET_DISCOUNT) + totals.shipping;
  const rblEquivalent =
    price.available && price.price_eur > 0
      ? Math.ceil(discountedTotal / price.price_eur)
      : null;

  return (
    <>
      <button
        onClick={() => { setOpen(true); onOpen?.(); }}
        className="group inline-flex w-full flex-col items-center justify-center gap-0.5 rounded-full border border-orange-400/60 bg-orange-400/[0.08] px-4 py-2.5 transition-all hover:-translate-y-0.5 hover:border-orange-300 hover:bg-orange-400/[0.14]"
        data-testid="market-rbl-pay-button"
      >
        <span className="inline-flex items-center gap-1.5 text-[11px] font-black uppercase tracking-[0.14em] text-orange-300 group-hover:text-orange-200">
          <Flame className="h-3.5 w-3.5" />
          {t.payWithRBL} · {t.discount25} · €{discountedTotal.toFixed(2)}
        </span>
        {rblEquivalent != null && (
          <span className="font-mono text-[10px] text-white/45" data-testid="market-rbl-button-equivalent">
            ≈ {rblEquivalent.toLocaleString()} R₿L
          </span>
        )}
      </button>
      {open && <RBLMarketCheckoutModal onClose={() => setOpen(false)} />}
    </>
  );
};

export default RBLPaymentButton;
